import {
  CLEAR_APPROVER_LIST,
  UPDATE_APPROVER_LIST,
  UPDATE_APPROVER_APPROVALS_LIST,
  UPDATE_APPROVER_PROFILE_IMAGE,
  FETCH_APPROVERS,
  FETCH_APPROVERS_START,
  FETCH_APPROVERS_SUCCESS,
  FETCH_APPROVERS_ERROR,
  FETCH_APPROVER_IMAGE,
  FETCH_APPROVER_IMAGE_START,
  FETCH_APPROVER_IMAGE_SUCCESS,
  FETCH_APPROVER_IMAGE_ERROR,
  FETCH_APPROVERS_APPROVALS,
  FETCH_APPROVERS_APPROVALS_START,
  FETCH_APPROVERS_APPROVALS_SUCCESS,
  FETCH_APPROVERS_APPROVALS_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clearApprovers = () => ({ type: CLEAR_APPROVER_LIST })
const updateApprovers = (approvers) => ({ type: UPDATE_APPROVER_LIST, approvers })
const updateApproversApprovals = (approvals) => ({ type: UPDATE_APPROVER_APPROVALS_LIST, approvals })
const updateApproverImage = (image) => ({ type: UPDATE_APPROVER_PROFILE_IMAGE, image })
const fetchApprovers = (workflowId) => ({ type: FETCH_APPROVERS, workflowId })
const fetchApproversStart = () => ({ type: FETCH_APPROVERS_START })
const fetchApproversSuccess = (approvers) => ({ type: FETCH_APPROVERS_SUCCESS, approvers })
const fetchApproversError = (error) => ({ type: FETCH_APPROVERS_ERROR, error })
const fetchApproverImage = (username) => ({ type: FETCH_APPROVER_IMAGE, username })
const fetchApproverImageStart = () => ({ type: FETCH_APPROVER_IMAGE_START })
const fetchApproverImageSuccess = (image) => ({ type: FETCH_APPROVER_IMAGE_SUCCESS, image })
const fetchApproverImageError = (error) => ({ type: FETCH_APPROVER_IMAGE_ERROR, error })
const startFetchApproversAsync = buildAsyncAction(
  FETCH_APPROVERS,
  FETCH_APPROVERS_START,
  [FETCH_APPROVERS_ERROR, FETCH_APPROVERS_SUCCESS]
)
const startFetchApproverImageAsync = buildAsyncAction(
  FETCH_APPROVER_IMAGE,
  FETCH_APPROVER_IMAGE_START,
  [FETCH_APPROVER_IMAGE_ERROR, FETCH_APPROVER_IMAGE_SUCCESS]
)
const startFetchApproversApprovalsAsync = buildAsyncAction(
  FETCH_APPROVERS_APPROVALS,
  FETCH_APPROVERS_APPROVALS_START,
  [FETCH_APPROVERS_APPROVALS_SUCCESS, FETCH_APPROVERS_APPROVALS_ERROR]
)
const fetchApproversApprovals = (workflowId) => ({ type: FETCH_APPROVERS_APPROVALS, workflowId })
const fetchApproversApprovalsStart = () => ({ type: FETCH_APPROVERS_APPROVALS_START })
const fetchApproversApprovalsSuccess = (approvals) => ({ type: FETCH_APPROVERS_APPROVALS_SUCCESS, approvals })
const fetchApproversApprovalsError = (error) => ({ type: FETCH_APPROVERS_APPROVALS_ERROR, error })

export {
  startFetchApproversAsync,
  startFetchApproversApprovalsAsync,
  startFetchApproverImageAsync,
  clearApprovers,
  updateApprovers,
  updateApproversApprovals,
  updateApproverImage,
  fetchApprovers,
  fetchApproversStart,
  fetchApproversSuccess,
  fetchApproversError,
  fetchApproverImage,
  fetchApproverImageStart,
  fetchApproverImageSuccess,
  fetchApproverImageError,
  fetchApproversApprovals,
  fetchApproversApprovalsStart,
  fetchApproversApprovalsSuccess,
  fetchApproversApprovalsError,
}
